import { API } from "../../../config";
import { LIST_LIMIT } from "../../../constants/constants";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { mockAPIPath, serverAPIPath } from "../config/apiPath";
import { ProductList, UnregisteredImageTypeWithPaginationType } from "../../../interfaces/UnregistredImagesInterface";

class UnregisteredImageService {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }

    async getProductsList(search: string) {
        const response = this.isHitDummyURL ?
            await new AxiosUtils(
                `${mockAPIPath.UNREGISTERED_IMAGE_LIST}`,
                this.payload,
                this.headers
            ).get() :
            await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.PRODUCTS_LIST}?&search=${search}`,
                this.payload,
                this.headers
            ).get();

        if (response.data.success) {
            const { data }: { data: ProductList[] } = response.data.data;
            return data;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async unregisteredImageList(page_id: number, sellerParam?: string, productParam?: string, limit: number = LIST_LIMIT.UNREGISTERED_IMAGE_LIST_LIMIT, colName?: string, order?: string, publicationStatus?: string) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.UNREGISTERED_IMAGE_LIST}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.UNREGISTERED_IMAGE_LIST}?page=${page_id}&sellerParam=${sellerParam}&productParam=${productParam}&order=${order}&limit=${limit}&flag=${publicationStatus}&column=${colName}`,
                this.payload,
                this.headers
            ).get();
        if (response?.data?.success) {
            const { data, currentPage, totalPages, currentTotalCount, totalCount, lastRefreshTimestamp } = response.data.data;
            const UnregisteredImageData: UnregisteredImageTypeWithPaginationType = {
                unregisteredImageLogs: data,
                pagination: {
                    currentPage,
                    totalPages,
                    currentTotalCount,
                    totalCount,
                },
                lastRefreshTimestamp: lastRefreshTimestamp
            };
            return UnregisteredImageData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async downloadCsv(sellerParam?: string, productParam?: string, limit = LIST_LIMIT.UNREGISTERED_IMAGE_LIST_LIMIT, colName?: string, order?: string, publicationStatus?: any) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.UNREGISTERED_IMAGE_LIST}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.UNREGISTERED_IMAGE_LIST}?sellerParam=${sellerParam}&productParam=${productParam}&order=${order}&limit=${limit}&column=${colName}&flag=${publicationStatus}&download=true`,
                this.payload,
                this.headers
            ).get();
        if (response?.data?.success) {
            const { data, currentPage, totalPages, currentTotalCount, totalCount } = response.data.data;
            const UnregisteredImageData: UnregisteredImageTypeWithPaginationType = {
                unregisteredImageLogs: data,
                pagination: {
                    currentPage,
                    totalPages,
                    currentTotalCount,
                    totalCount,
                },
            };
            return UnregisteredImageData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async refreshUnregisteredImageService() {
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.REFRESH_URL}`, this.payload, this.headers).post();
        let responseMessage: any;
        if (response?.data?.success == true) {
            responseMessage = response?.data;
            return responseMessage;
        }
        else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

}

export default UnregisteredImageService;